<template>
  <div class="content">
    <van-tabs v-model="active" line-height="2px" color="#45B9BC" sticky>
      <van-tab title="门店">
        <van-list v-model="store_loading" :finished="store_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="tab__content">
            <router-link :to="{ path: '/storeDetails', query: { id: storeItem.id }}" class="storeList flex_center" v-for="(storeItem,storeIndex) in storeList" :key="storeIndex">
              <div class="storeList__img"><img :src="storeItem.logo" alt=""></div>
              <div class="storeList__content">
                <div class="flex storeList__line">
                  <div>{{storeItem.storename}}</div>
                  <div class="storeList__distance" v-if="storeItem.juli">
                    <span class="iconfont icon-loc-s col_00A29A"></span>
                    <p >{{storeItem.juli}}</p>
                  </div>
                 
                </div>
                <div class="col_999 fs_12 storeList__subtitle">
                  <p>地址：{{storeItem.address}}</p>
                  <p>电话：{{storeItem.tel}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="项目">
        <van-list v-model="item_loading" :finished="item_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="itemList">
            <ul>
              <li class="fl" v-for="(item,index) in itemList" :key="index">
                <router-link :to="{ path: '/itemDetails', query: { service_id: item.id }}" class="bg_fff radius3">
                  <img :src="item.thumb_frist" alt="">
                  <div class="itemList_content">
                    <p class="itemList_title one">{{item.title}}</p>
                    <p class="itemList_price"><span>￥{{item.price}} 起</span>{{item.itemtime}}分钟/次</p>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="技师">
        <van-list v-model="tech_loading" :finished="tech_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="tech_level"><div @click="select_level(level_item.id)" :class="['evaluate__tabTitle',level_active==level_item.id?'active':'']" v-for="(level_item,level_index) in tech_level" :key="level_index"><span>{{level_item.title}}</span></div></div>
          <div class="tab__content">
            <div class="storeList flex_center techList" v-for="(techItem,techIndex) in techList" :key="techIndex">
              <!--技师头像-->
              <div class="tech__headBox" v-if="techItem.type=='2'">
                <img class="tech__headImg seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
                <img class="tech__head_crown" src="../../../static/img/crown_icon.png" alt />
              </div>
              <div class="tech__headBox" v-if="techItem.type=='1'">
                <img class="tech__headImg seniorTech seniorTech2" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
                <img class="tech__head_crown" src="../../../static/img/crown_icon2.png" alt />
              </div>
              <div class="tech__headBox" v-if="techItem.type=='0'">
                <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
              </div>
              <!--技师内容-->
              <div class="storeList__content">
                <div class="flex_center techList__title">
                  <span>{{techItem.name}}</span>
                  <div class="detail_star">
                    <span v-for="(item,index) in 5" :key="index">
                      <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                      <van-icon class="star" size="15px" name="star" v-else/>
                    </span>
                  </div>
                </div>
                <div class="col_999 fs_12">
                  <p>{{techItem.levelname}}</p>
                  <div class="flex techList__line">
                    <div>个人编号：{{techItem.num_id}}</div>
                    <router-link :to="{ path: '/technicianDetails', query: { tech_id: techItem.id }}"  class="techList__btn">立即预约</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
    <!--底部固定导航-->
    <tab-bar :book-active="'active'" :book-icon="'../../static/img/icon_nav22.png'"></tab-bar>
  </div>
</template>

<script>
  import tabBar from "@/components/tabBar.vue";   //引入底部组件
  export default {
    name: "book",
    components: { tabBar },
    data() {
      return {
        active: 0,  //顶部标签当前位置
        star_active: "#F9CE06",   //星星
        //门店列表
        storeList: [
          // {
          //   img_url: '../../../static/img/store_img1.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '../../../static/img/store_img1.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '../../../static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '../../../static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '../../../static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '../../../static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // }
        ],
        //项目列表
        itemList: [
          // {img:"../../static/img/itemList_img1.png",title:"体验按摩",price:"39.00",time:"15"},
          // {img:"../../static/img/itemList_img2.png",title:"推油养生",price:"320.00",time:"60"},
          // {img:"../../static/img/itemList_img3.png",title:"拔罐养生",price:"60.00",time:"10"}
        ],
        //技师列表
        techList: [
          // {
          //   type:'2',
          //   headImg: '../../static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'首席技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },{
          //   type:'1',
          //   headImg: '../../static/img/tech_head2.png',
          //   name: '成技师',
          //   grade:'资深技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },{
          //   type:'0',
          //   headImg: '../../static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:4,
          //   perNum:"1234444222"
          // },{
          //   type:'0',
          //   headImg: '../../static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },
        ],
        tech_level:[],
        level_active:0,

        store_loading: false,
        store_finished: true,
        item_loading: false,
        item_finished: true,
        tech_loading: false,
        tech_finished: true,
        lat:0,
        lng:0,

      }
    },
   
    created(){
      var that = this;
     
      this.get_book();
    },
    methods: {
      onLoad() {
        // 异步更新数据

      }, 
    
      select_level(level_id){
          this.level_active = level_id;
          this.get_book();
      },
      get_book(){
        var  that = this;
         this.wx.wxgetlocation(result=>{    
          // console.log("地址参数  "+JSON.stringify(result));  
          // that.lat = result.latitude
          // that.lng = result.longitude
          this.axios({
            url: this.api.book.book_list,
            data:{
                'tech_level_id':this.level_active,
                'lat':result.latitude,
                'lng':result.longitude,
            }
            }).then((res) => {
              if (res.error === 0) {
                this.storeList  = res.store_list 
                this.itemList  = res.service_list 
                this.techList  = res.tech_list           
                this.tech_level = res.tech_level
                this.level_active = res.select_level
              }

          })
         },()=>{
           this.axios({
            url: this.api.book.book_list,
            data:{
                'tech_level_id':this.level_active,
                'lat':0,
                'lng':0,
            }
            }).then((res) => {
              if (res.error === 0) {
                this.storeList  = res.store_list 
                this.itemList  = res.service_list 
                this.techList  = res.tech_list           
                this.tech_level = res.tech_level
                this.level_active = res.select_level
              }

          })
         });
        
      }
    },
  };
</script>
<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*(服务)项目样式*/
  @import '../../assets/css/technician.css';   /*技师样式*/
  .tab__content{
    padding-top: .25rem;
  }
  .storeList__subtitle{
    margin-top: 0;
  }
  .tech_level{
      background: white;
      margin-top: 0.2rem;
      overflow: hidden;
      text-align: center;

  }
   .evaluate__tabTitle{
      color: #999;
      border: 1px solid #ccc;
      line-height: 1.2rem;
      margin: .45rem .1rem;
      border-radius: 1.2rem;
      font-size: .6rem;
      display: inline-block;
      margin-left: 0.5rem;
  }
  .evaluate__tabTitle span{
    padding: 0.5rem;
  }
  .active {
    color: #45B9BC;
    border-color: rgba(69, 185, 188, .5);
  }
</style>



// WEBPACK FOOTER //
// src/views/book/book.vue